'use strict';

;(function () {
  let addToCartBtns, pdpSimlpeContainer;
  let ADD_TO_CART_T, SOLD_OUT_T;

  function checkSafetyStock(){
    let selectedVariantId, selectedVariant;

    // Validation only for members
    if(!addToCartBtns || addToCartBtns.length == 0){
      return;
    }
    
    selectedVariantId = getSelectedVariantId();
    selectedVariant = window.EBSDataLayer.product.variants.find((v) => { return v.id == selectedVariantId });

    addToCartBtns.forEach((addToCartBtn) => {
      if(!window.EBSDataLayer.product.safetyStockLevel) {
        return;
      }
      
      if(selectedVariant.inventoryQuantity <= window.EBSDataLayer.product.safetyStockLevel){
        addToCartBtn.innerText = SOLD_OUT_T;
        addToCartBtn.setAttribute('disabled', true);
      } else {
        addToCartBtn.innerText = ADD_TO_CART_T;
        addToCartBtn.removeAttribute('disabled');
      }
    });
  }

  function getSelectedVariantId(){
    return document.querySelector('[name="id"]:checked').value;
  }
  
  function onDocumentLoaded(){
    addToCartBtns = document.querySelectorAll('.pdp-buttons .add-to-cart');
    pdpSimlpeContainer = document.querySelector('.pdp-simple');

    ADD_TO_CART_T = pdpSimlpeContainer.dataset.addToCartT;
    SOLD_OUT_T = pdpSimlpeContainer.dataset.soldOutT;

    document.querySelectorAll('[name="id"]').forEach((variantRadioBtn) => {
      variantRadioBtn.addEventListener('change', selectedVariantRadioChanged);
    });

    checkSafetyStock();
  }

  function selectedVariantRadioChanged(e){
    if(e.currentTarget.checked){
      checkSafetyStock();
    }
  }
  
  if(document.readyState != 'loading'){
    onDocumentLoaded();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentLoaded);
  }
})();